<script>
export default {
    name: "login-submit-button",
    props: {
        disabled: Boolean,
    }
}
</script>

<template>
    <v-btn @click="$emit('click')" :disabled="disabled" type="submit" class="btn btn-primary full-width">
        <slot/>
    </v-btn>
</template>
